import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import styles from "./styles/hamburger.module.scss";
import { Divider } from "./divider";

interface HamburgerMenuProps {
  onClick?: () => void;
}

export const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ onClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (onClick) onClick();
  };

  return (
    <button
      onClick={toggleMenu}
      className={`${styles.hamburger} ${isOpen ? styles.open : ""}`}
      aria-label="Toggle menu"
    >
      <span />
      <span />
      <span />
    </button>
  );
};

interface SidebarMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SidebarMenu: React.FC<SidebarMenuProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const location = useLocation();

  function scrollToElement(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  function handleNavigationAndScroll(targetId: string) {
    if (location.pathname !== "/") {
      navigate("/", { replace: false });

      setTimeout(() => {
        scrollToElement(targetId);
      }, 100);
    } else {
      scrollToElement(targetId);
    }

    onClose();
  }

  return (
    <div className={`${styles.sidebar} ${isOpen ? styles.open : ""}`}>
      <div className={styles.overlay} onClick={onClose} />
      <div className={styles.menu}>
        <div className={styles.header}>
          <span>Navigation</span>
          <button
            onClick={onClose}
            className={`${styles.hamburger} ${isOpen ? styles.open : ""}`}
            aria-label="Toggle menu"
          >
            <span className={styles.burgerLine} />
            <span className={styles.burgerLine} />
            <span className={styles.burgerLine} />
          </button>
        </div>
        <Divider width={"100%"} margin={"10px"} />
        <ul>
          <li>
            <div className={styles.items} onClick={() => handleNavigationAndScroll("maskSection")}>
              Appara Face mask
            </div>
          </li>
          <li>
            <div
              className={styles.items}
              onClick={() => handleNavigationAndScroll("mobileAppSection")}
            >
              Appara Mobile app
            </div>
          </li>
          <li>
            <div className={styles.items} onClick={() => handleNavigationAndScroll("news")}>
              News
            </div>
          </li>
        </ul>
        <Divider width={"100%"} margin={"10px"} />
        <ul>
          {/* 
          TO BE DONE
          <li>
            <div className={styles.items} onClick={() => navigate("/")}>
              Contact us
            </div>
          </li> */}
          <li>
            <div className={styles.items} onClick={() => navigate("/products")}>
              Our Products
            </div>
          </li>
          <li>
            <div className={styles.items} onClick={() => navigate("/calculator")}>
              Calculator
            </div>
          </li>
          <li>
            <div className={styles.items} onClick={() => navigate("/")}>
              Home
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
